export const ROUTES = {
  HOME: "/home",
  ADMIN: "/admin",
  POST: "/home/:id",
  PRIVACY_POLICY: "/maadhyam-privacy-policy",
};
